import * as React from "react";
import { styled } from "@mui/material";
import clsx from "clsx";
import { useRef } from "react";
import {
  PatientDoorReportData,
  PatientInfoReportData,
} from "../patientVisitData";

//region [[ Styles ]]

const Debug = styled("div")({
  zIndex: 2,
  opacity: 0,
  height: 0,
  overflow: "hidden",
  transition: "all 0.5s ease-out",
  flex: 0,
  "&.open": {
    flex: 3,
    opacity: 1,
    height: "500px",
    overflow: "auto",
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface ImportPatientDebugProps {
  isDebugOpen: boolean;
  patientVisitData: PatientDoorReportData[];
  patientInfo: PatientInfoReportData[];
  displayText: React.ReactNode;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ImportPatientDebug = ({
  isDebugOpen,
  patientVisitData,
  patientInfo,
  displayText,
  ...props
}: ImportPatientDebugProps) => {
  const queryParams = useRef(new URLSearchParams(window?.location?.search));

  return (
    <Debug className={clsx(isDebugOpen ? "open" : "")}>
      {(!queryParams?.current?.has("debug") ||
        queryParams?.current?.get("debug") === "all") && (
        <>
          <pre>
            <code>{JSON.stringify(patientVisitData, null, 4)}</code>
          </pre>
          <pre>
            <code>{JSON.stringify(patientInfo, null, 4)}</code>
          </pre>
        </>
      )}
      <pre>
        <code>{displayText}</code>
      </pre>
    </Debug>
  );
};
